import { render, staticRenderFns } from "./AssignVendorTeamsForm.vue?vue&type=template&id=42b4d3fe&scoped=true&"
import script from "./AssignVendorTeamsForm.vue?vue&type=script&lang=js&"
export * from "./AssignVendorTeamsForm.vue?vue&type=script&lang=js&"
import style0 from "./AssignVendorTeamsForm.vue?vue&type=style&index=0&id=42b4d3fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b4d3fe",
  null
  
)

export default component.exports